<template>
  <router-view v-if="available" />
  <technical-break v-else />
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useHead } from '@unhead/vue'
import { useInitStore } from '@/stores/init'
import TechnicalBreak from '@/views/layouts/TechnicalBreak.vue'

const initStore = useInitStore()
const { settings, available } = storeToRefs(initStore)

const headData = computed(() => {
  const { favicon_url, registration_css_url, js_url, brand_name } =
    settings.value

  const linkConfig = [
    favicon_url && { rel: 'icon', href: favicon_url },
    registration_css_url && { rel: 'stylesheet', href: registration_css_url },
  ]

  const scriptConfig = [js_url && { src: js_url }]

  return {
    title: brand_name ? `Welcome to ${brand_name} | Registration` : undefined,
    link: linkConfig.filter(Boolean),
    script: scriptConfig.filter(Boolean),
  }
})

useHead(headData)
</script>

<style lang="less" src="./assets/css/main.less"></style>
